export default __webpack_public_path__ + "static/media/Logo-Tow-Pro-onDark-RGB.d32ce2d4.png";